<template>
  <button
    type="button"
    data-test="support-callout"
    class="w-full flex items-center justify-between gap-3 text-left rounded-xl bg-yellow-50 border border-yellow-100 p-5 hover:shadow-md transition-shadow"
    @click="openIntercom"
  >
    <span class="flex items-center gap-3 min-w-0">
      <img :src="supportImage" :alt="t('image_alt')" class="h-10 w-10 shrink-0 rounded-full object-cover" />
      <span class="min-w-0">
        <span class="block text-lg font-bold text-gray-900">{{ t("title") }}</span>
        <span class="block text-sm text-yellow-600">{{ t("subtitle") }}</span>
      </span>
    </span>
    <span class="shrink-0 rounded-full bg-gray-900 p-2.5 text-white" :title="t('contact')">
      <ChatIcon class="h-4 w-4" />
    </span>
  </button>
</template>

<script>
import { useI18n } from "vue-i18n";
import { ChatIcon } from "@heroicons/vue/solid";
import { sendIntercomMessage } from "@/utils/intercom";
import supportImage from "@/assets/support-image.png";

// Support of the POS home: the whole block opens a conversation with Estaly, compact enough for a narrow column.
export default {
  components: {
    ChatIcon,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return { supportImage };
  },

  methods: {
    openIntercom() {
      sendIntercomMessage("");
    },
  },
};
</script>

<i18n src="./SupportCallout.i18n.json"></i18n>
